import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import ConversationMessages from "./ConversationMessages";
import { fetchAllMembers } from "../../features/team-member/teamMemberSlice";
import { fetchConversationBySettingId } from "../../features/integration-setting/integrationSettingSlice";

function ConversationList() {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const groupFromUrl = searchParams.get("group");

  const {
    conversationGroups,
    conversationsLoading,
    currentConversation,
    currentConversationLoading,
  } = useSelector((state) => state.integrationSetting);

  const isAllConversations = !groupFromUrl;

  useEffect(() => {
    dispatch(fetchAllMembers());
  }, [dispatch]);

  const selectedGroupMeta =
    conversationGroups.find((g) => g.key === (groupFromUrl || "all")) || null;

  const integrationSettingId = selectedGroupMeta
    ? (selectedGroupMeta.integrationSettingId ??
      selectedGroupMeta.settingId ??
      selectedGroupMeta.key)
    : null;

  useEffect(() => {
    if (!isAllConversations && integrationSettingId) {
      dispatch(fetchConversationBySettingId(integrationSettingId));
    }
  }, [isAllConversations, integrationSettingId, dispatch]);

  const selectedGroup =
    !isAllConversations && selectedGroupMeta
      ? currentConversation?.settingId === integrationSettingId ||
        currentConversation?.integrationSettingId === integrationSettingId
        ? { ...selectedGroupMeta, ...currentConversation }
        : selectedGroupMeta
      : selectedGroupMeta;

      const taskId = !isAllConversations ? (selectedGroup?.taskId ?? null) : null;

  const isLoading = isAllConversations
    ? conversationsLoading
    : currentConversationLoading;

  return (
    <div className="d-flex flex-column px-3 pb-3 py-10 conv-page">
      <div className="d-flex flex-row border rounded-3 bg-container flex-grow-1 overflow-hidden">
        <ConversationMessages
          group={selectedGroup}
          isLoading={isLoading}
          isAllConversations={isAllConversations}
          integrationSettingId={integrationSettingId}
          taskUuid={taskId}
        />
      </div>
    </div>
  );
}

export default ConversationList;
